import React, { useEffect, useRef } from "react";
import topSvg from "../../assets/svg/top.svg";
import bottomSvg from "../../assets/svg/bottom.svg";
import mainLogoSvg from "../../assets/img/Main logo.png";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuthObj, 
  login,
} from "../../features/auth/authSlice";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { clearFetchObj } from "../../features/fetch/fetchSlice";
import { clearGlobalObj } from "../../features/global/globalSlice";
function Login() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { authLoading } = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(login(data));
    if (res?.payload?.success) { 
      await toast.success(
        res?.payload?.message ?? "Login successfull"
      );
      await form.resetFields();
      await navigate('/login-otp') 
    } else {
      toast.error(res?.payload?.message ?? "Invalid Credentials");
    }
  };

  useEffect(() => {
    dispatch(clearAuthObj());
    dispatch(clearFetchObj())
    dispatch(clearGlobalObj())
    localStorage.clear();
  }, []);

  return (
    <div className="w-full h-full min-h-screen flex flex-col op-bg">
      <div>
        <img src={topSvg} alt="topSvg"  />
      </div>
      <div className="w-full flex flex-col h-full lg:px-0 px-3 lg:items-center lg:justify-center ">
        <div className="login-card lg:p-[2.5rem] p-3">
          <div>
            <img src={mainLogoSvg} alt="mainLogoSvg" className="cursor-pointer" onClick={()=>navigate('/')}/>
          </div>
          <div className="typography_1 mt-[2.5rem]">
            Sign in to your account
          </div>
          <div className="typography_2">
            Welcome to State Department for Irrigation.
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="lg:w-[34.25rem] w-full"
            style={{
              maxWidth: "100%",
              marginTop: "2.06rem",
            }}
            form={form}
          >
            <Form.Item
              name="nationalId"
              label="ID Number"
              rules={[
                {
                  required: true,
                  message: "ID Number is required to login",
                },
              ]}
            >
              <Input placeholder="ID Number" className="input" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Please enter your password",
                },
              ]}
            >
              <Input.Password placeholder="password" className="input" />
            </Form.Item>

            <div className="flex justify-center w-full mt-[1rem]">
              <button
                className="cstm-btn-2"
                type="submit"
                disabled={authLoading ? true : false}
              >
                {authLoading ? <Spin /> : "Login"}
              </button>
            </div>

            <div className="flex justify-between mt-[1rem]">
              <Link onClick={()=>navigate('/forgot-email')} className="forgot-text">Forgot Password?</Link>
              <Link className="forgot-text !text-[#0092CC]">Help</Link>
            </div>
          </Form>
        </div>
      </div>
      <div className="w-full  mt-auto flex flex-col items-center justify-center bottom-0">
        <span className="text-[#424242] text-[.875rem] font-[400] font-sora pb-[1rem]">
          Powered by{" "}
          <a
            href="https://spa-limited.com/"
            target="_blank"
            rel="noreferrer"
            className="text-[#0092CC] hover:underline"
          >
            Smart People Africa
          </a>
        </span>
        <img src={bottomSvg} alt="bottomSvg" />
      </div>
    </div>
  );
}

export default Login;
